import axios from 'axios';
import { Component } from 'react';
import { Button, Card, Form, Image, InputGroup, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { DarkElectricBlue, GammaBlue, White } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';
const apiURL = process.env.REACT_APP_API_URL;
const processPaymentURL = 'https://educoreparentapi.educore.io/payment-gateway-jis-hyperpay/process-payment'
class PaymentGatewayJisHyperpay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prepareCheckOutData: null,
            balance: 0,
        };
        this.hyperPayScript = null
    }

    componentDidMount() {
        if (this.props.params) {
            this.setState({ balance: this.props.params.balance })

        }
    }

    componentDidUpdate(prevProps, prevState) {

    }

    componentWillUnmount() {
        if (this.hyperPayScript) {
            document.body.removeChild(this.hyperPayScript);
        }
    }

    prepareCheckout = async (balance) => {
        if (this.prepareCheckoutReq) {
            this.prepareCheckoutReq.abort();
        }
        this.prepareCheckoutReq = new AbortController();
        try {
            let fData = new FormData()
            fData.append('amount', balance)
            const res = await axios.post(apiURL + 'payment-gateway-jis-hyperpay/prepare-checkout', fData, {
                signal: this.prepareCheckoutReq.signal,
                params: {
                    tenant_id: this.props.tenant_id,
                    appname: process.env.REACT_APP_NAME,
                },
            })
            console.log('res', res);
            if (res) {
                let resData = res.data
                if (resData.type) {
                    let prepareCheckOutData = resData.data
                    this.setState({ prepareCheckOutData: prepareCheckOutData })
                    this.hyperPayScript = document.createElement('script');
                    this.hyperPayScript.src = `https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=${prepareCheckOutData.id}`;
                    this.hyperPayScript.async = false;
                    this.hyperPayScript.crossOrigin = 'anonymous';
                    this.hyperPayScript.integrity = prepareCheckOutData.integrity;
                    document.body.appendChild(this.hyperPayScript);
                    //       <script
                    //     src={"https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=" + prepareCheckOutData.id}
                    //     integrity={prepareCheckOutData.integrity}
                    //     crossOrigin="anonymous">
                    // </script>
                }
                toast[resData.messageType](resData.message);
            }
        } catch (error) {

        }
    }


    render() {
        let { params } = this.props
        let { prepareCheckOutData, balance } = this.state

        if (prepareCheckOutData) {
            var payment_gateway_url = new URL(processPaymentURL);
            payment_gateway_url.searchParams.append('center_id', params.center_id);
            payment_gateway_url.searchParams.append('parent_id', params.parent_id);
            payment_gateway_url.searchParams.append('child_id', params.child_id);
            payment_gateway_url.searchParams.append('user_id', params.user_id);
            payment_gateway_url.searchParams.append('actionType', params.actionType);
            payment_gateway_url.searchParams.append('tenant_id', this.props.tenant_id);
            return (<Card className='border-0' style={{ borderRadius: '20px', marginTop: 20, width: '90%' }}>
                <Card.Body>
                    <form action={payment_gateway_url} className="paymentWidgets" data-brands="MADA VISA MASTER AMEX"></form>
                </Card.Body>
            </Card>)
        }

        return (
            <Card className='border-0' style={{ borderRadius: '20px', marginTop: 20, width: '90%' }}>
                <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
                    <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>Payment</div>
                </Card.Header>
                <Card.Body>
                    <Table borderless striped>
                        <thead>
                            <tr>
                                <th style={{ fontSize: 16, textAlign: 'center', color: DarkElectricBlue }} colSpan={2}>Summary</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th style={{ textAlign: 'center', width: '50%' }}>Parent Name</th>
                                <td style={{ textAlign: 'left' }}>{params.parent_name}</td>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'center', width: '50%' }}>Student Name</th>
                                <td style={{ textAlign: 'left' }}>{params.child_name}</td>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'center', width: '50%' }}>Amount Due</th>
                                <td style={{ textAlign: 'left' }}>
                                    <InputGroup >
                                        <Form.Control
                                            placeholder={t('Amount')}
                                            readOnly={params.balanceReadonly}
                                            type='number'
                                            value={balance}
                                            onChange={(e) =>
                                                this.setState({ balance: e.target.value })
                                            }
                                        />
                                        <InputGroup.Text>{params.currencycode}</InputGroup.Text>
                                    </InputGroup>
                                    {/* {params.balance} */}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            {/* PAYMENT METHOD ICONS */}
                            <tr>
                                <td colSpan={2} style={{ textAlign: 'center', }}>
                                    <div className='d-flex flex-row align-items-center justify-content-center'>
                                        <Image src={require('../../assets/payment-methods/american-express.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/mada.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/mastercard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                        <Image src={require('../../assets/payment-methods/visacard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </Card.Body>
                <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
                    <Button variant='primary' style={{ width: '100%' }} onClick={() => this.prepareCheckout(balance)}>
                        <div className='d-flex flex-row justify-content-center align-content-center'>
                            <div className='mx-1'>{t('Pay Now')}</div>
                            <div className='mx-1' style={{ fontWeight: 600 }}>{params.currencycode}</div>
                            <div className='mx-1 px-2' style={{ backgroundColor: White, borderRadius: 20, color: GammaBlue, fontWeight: 600 }}>{balance}</div>
                        </div>
                    </Button>
                </Card.Footer>
            </Card>
        )
    }
}

const mapStateToProps = (state) => ({
    langLabels: state.language.langLabels,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps())(PaymentGatewayJisHyperpay);